import type { OptionsAPI } from './useOptions'
import GeneralSection from './system/GeneralSection'
import SMTPSection from './system/SMTPSection'
import EmailDomainSection from './system/EmailDomainSection'
import TurnstileSection from './system/TurnstileSection'
import OAuthProvidersSection from './system/OAuthProvidersSection'
import PasskeySection from './system/PasskeySection'
import SSRFSection from './system/SSRFSection'
import CustomOAuthProvidersSection from './system/CustomOAuthProvidersSection'

export default function SystemSetting({ options }: { options: OptionsAPI }) {
  return (
    <div>
      <GeneralSection options={options} />
      <SMTPSection options={options} />
      <EmailDomainSection options={options} />
      <TurnstileSection options={options} />
      <OAuthProvidersSection options={options} />
      <CustomOAuthProvidersSection options={options} />
      <PasskeySection options={options} />
      <SSRFSection options={options} />
    </div>
  )
}
